import DsLog from 'DsWebLogSender'

DsLog.init({
  table: 'weblog-common',
  env: process.env.VUE_APP_APP_LOG_ENV,
  field: {
    screenName: '',
    group: '',
    service: 'baemin-market'
  }
})

function addLog(memberNo, sessionId, deviceId, screenName, type, group, event, params) {
  const unixTimestamp = Math.floor(new Date().getTime() / 1000)
  new Promise(() => {
    DsLog.log({
      timestamp: unixTimestamp,
      memNo: memberNo,
      sessionId,
      dvcId: deviceId,
      screenName,
      type,
      group,
      event,
      params
    })
  }).then()
}

const LogScreenName = Object.freeze({
  MARKET_CART: 'Market/Cart',
  MARKET_ORD: 'Market/Ord',
  MARKET_ORD_HIST: 'Market/OrdHist'
})

const LogType = Object.freeze({
  VIEW: 'View',
  CLICK: 'Click'
})

const LogGroup = Object.freeze({
  DEFAULT: '',
  CART_DET: 'CartDet',
  PRODUCT_DET: 'ProductDet'
})

const LogEvent = Object.freeze({
  DEFAULT: '',
  ORD: 'Ord',
  PRODUCT_DET: 'ProductDet',
  DEL_ORD: 'DelOrd'
})

const AppLog = {}

AppLog.install = Vue => {
  Vue.prototype.$appLog = {
    cartViewLog: (memberId, sessionId, deviceId, params) => {
      const screenName = LogScreenName.MARKET_CART
      const type = LogType.VIEW
      const group = LogGroup.DEFAULT
      const event = LogEvent.DEFAULT
      addLog(memberId, sessionId, deviceId, screenName, type, group, event, params)
    },
    cartToOrderClickLog: (memberId, sessionId, deviceId, params) => {
      const screenName = LogScreenName.MARKET_CART
      const type = LogType.CLICK
      const group = LogGroup.CART_DET
      const event = LogEvent.ORD
      addLog(memberId, sessionId, deviceId, screenName, type, group, event, params)
    },
    moveCartItemClickLog: (memberId, sessionId, deviceId, params) => {
      const screenName = LogScreenName.MARKET_CART
      const type = LogType.CLICK
      const group = LogGroup.PRODUCT_DET
      const event = LogEvent.PRODUCT_DET
      addLog(memberId, sessionId, deviceId, screenName, type, group, event, params)
    },
    deleteCartItemClickLog: (memberId, sessionId, deviceId, params) => {
      const screenName = LogScreenName.MARKET_CART
      const type = LogType.CLICK
      const group = LogGroup.PRODUCT_DET
      const event = 'Delete'
      addLog(memberId, sessionId, deviceId, screenName, type, group, event, params)
    },
    adjustCartItemQuantityClickLog: (memberId, sessionId, deviceId, params) => {
      const screenName = LogScreenName.MARKET_CART
      const type = LogType.CLICK
      const group = LogGroup.PRODUCT_DET
      const event = 'Qty'
      addLog(memberId, sessionId, deviceId, screenName, type, group, event, params)
    },
    selectAllCartItemClickLog: (memberId, sessionId, deviceId, params) => {
      const screenName = LogScreenName.MARKET_CART
      const type = LogType.CLICK
      const group = 'CartDet'
      const event = 'AllSelect'
      addLog(memberId, sessionId, deviceId, screenName, type, group, event, params)
    },
    deleteSelectCartItemClickLog: (memberId, sessionId, deviceId, params) => {
      const screenName = LogScreenName.MARKET_CART
      const type = LogType.CLICK
      const group = 'CartDet'
      const event = 'Delete'
      addLog(memberId, sessionId, deviceId, screenName, type, group, event, params)
    },
    showMoreProductClickLog: (memberId, sessionId, deviceId, params) => {
      const screenName = LogScreenName.MARKET_CART
      const type = LogType.CLICK
      const group = 'CartDet'
      const event = 'More'
      addLog(memberId, sessionId, deviceId, screenName, type, group, event, params)
    },
    purchaseViewLog: (memberId, sessionId, deviceId, params) => {
      const screenName = LogScreenName.MARKET_ORD
      const type = LogType.VIEW
      const group = ''
      const event = ''

      addLog(memberId, sessionId, deviceId, screenName, type, group, event, params)
    },
    purchaseClickLog: (memberId, sessionId, deviceId, params) => {
      const screenName = LogScreenName.MARKET_ORD
      const type = LogType.CLICK
      const group = 'Ord'
      const event = 'Ord'

      addLog(memberId, sessionId, deviceId, screenName, type, group, event, params)
    },
    purchMethodViewLog: (memberId, sessionId, deviceId, params) => {
      const screenName = 'Market/Ord/PurchMethod'
      const type = LogType.VIEW
      const group = ''
      const event = ''

      addLog(memberId, sessionId, deviceId, screenName, type, group, event, params)
    },
    purchMethodApplyClickLog: (memberId, sessionId, deviceId, params) => {
      const screenName = 'Market/Ord/PurchMethod'
      const type = LogType.CLICK
      const group = 'Apply'
      const event = 'PurchMethod'

      addLog(memberId, sessionId, deviceId, screenName, type, group, event, params)
    },
    ordHistoryViewLog: (memberId, sessionId, deviceId, params) => {
      const screenName = 'Market/OrdHist'
      const type = LogType.VIEW
      const group = ''
      const event = ''

      addLog(memberId, sessionId, deviceId, screenName, type, group, event, params)
    },
    ordDetailViewLog: (memberId, sessionId, deviceId, params) => {
      const screenName = 'Market/OrdDet'
      const type = LogType.VIEW
      const group = ''
      const event = ''

      addLog(memberId, sessionId, deviceId, screenName, type, group, event, params)
    },
    ordDetailCallCenterClickLog: (memberId, sessionId, deviceId, params) => {
      const screenName = 'Market/OrdDet'
      const type = LogType.CLICK
      const group = 'Call'
      const event = 'CenterCall'

      addLog(memberId, sessionId, deviceId, screenName, type, group, event, params)
    },
    // M4-1
    ordDetailDeleteLog: (memberId, sessionId, deviceId, params) => {
      const screenName = LogScreenName.MARKET_ORD_HIST
      const type = LogType.CLICK
      const group = LogEvent.ORD
      const event = LogEvent.DEL_ORD

      addLog(memberId, sessionId, deviceId, screenName, type, group, event, params)
    }
  }
}

export default AppLog
